/**
 * ir-braze-storage.js
 *
 * Identity persistence for Braze user tracking on intimaterose.com.
 *
 * Cookie `ir_braze_id` scoped to `.intimaterose.com` provides cross-subdomain
 * reach (main site, secure.intimaterose.com, checkout). localStorage backs it
 * up on the same origin and heals the cookie if cleared independently.
 *
 * The cookie contains the Braze external_id (sha256 hash of the user's email).
 * No PII in the cookie — only the hash. Email is stored separately in
 * localStorage for the setEmail() call.
 *
 * Safari ITP 7-day JS-cookie cap is accepted for v1; active users renew the
 * cookie on every identify so only 8+ day gaps cause re-anonymization.
 *
 * Exposes: window.irBrazeStorage
 * Dependencies: none
 */
(function () {
  'use strict';

  var COOKIE_NAME  = 'ir_braze_id';
  var LS_ID_KEY    = 'ir_braze_external_id';
  var LS_EMAIL_KEY = 'ir_braze_email';
  var LS_KNOWN_KEY = 'ir_braze_known';
  var LS_KNOWN_AT  = 'ir_braze_known_at';
  var COOKIE_DAYS  = 365;

  function getCookieDomain() {
    // On *.intimaterose.com -> scope cross-subdomain.
    // On myshopify.com preview or 127.0.0.1 -> host-only (no domain attr).
    if (/(^|\.)intimaterose\.com$/.test(location.hostname)) return '.intimaterose.com';
    return '';
  }

  function readCookie(name) {
    if (typeof document === 'undefined' || !document.cookie) return null;
    var nameEQ = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var c = parts[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) {
        try { return decodeURIComponent(c.substring(nameEQ.length)); }
        catch (_) { return null; }
      }
    }
    return null;
  }

  function writeCookie(name, value) {
    if (value == null || value === '') return;
    var d = new Date();
    d.setTime(d.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
    var parts = [
      name + '=' + encodeURIComponent(value),
      'expires=' + d.toUTCString(),
      'path=/',
      'SameSite=Lax'
    ];
    if (location.protocol === 'https:') parts.push('Secure');
    var dom = getCookieDomain();
    if (dom) parts.push('domain=' + dom);
    try { document.cookie = parts.join('; '); } catch (_) {}
  }

  function deleteCookie(name) {
    var base = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    var dom = getCookieDomain();
    try {
      if (dom) document.cookie = base + '; domain=' + dom;
      document.cookie = base;
    } catch (_) {}
  }

  function lsGet(key) {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  }
  function lsSet(key, value) {
    try { localStorage.setItem(key, value); } catch (_) {}
  }
  function lsRemove(key) {
    try { localStorage.removeItem(key); } catch (_) {}
  }

  window.irBrazeStorage = {
    getId: function () {
      var fromCookie = readCookie(COOKIE_NAME);
      if (fromCookie) return fromCookie;
      var fromLs = lsGet(LS_ID_KEY);
      if (fromLs) {
        writeCookie(COOKIE_NAME, fromLs);
        return fromLs;
      }
      return null;
    },

    setId: function (externalId) {
      if (!externalId) return;
      writeCookie(COOKIE_NAME, externalId);
      lsSet(LS_ID_KEY, externalId);
      lsSet(LS_KNOWN_KEY, '1');
      lsSet(LS_KNOWN_AT, String(Date.now()));
    },

    clear: function () {
      deleteCookie(COOKIE_NAME);
      lsRemove(LS_ID_KEY);
      lsRemove(LS_EMAIL_KEY);
      lsRemove(LS_KNOWN_KEY);
      lsRemove(LS_KNOWN_AT);
    },

    setEmail: function (email) {
      if (!email) return;
      lsSet(LS_EMAIL_KEY, email);
    },

    getEmail: function () {
      return lsGet(LS_EMAIL_KEY);
    }
  };
})();
